<template>
  <el-dialog :title="receiveData.title" :visible.sync="centerDialogVisible" @close="closeDialog" width="32%" center class="add-media">
    <el-form label-position="right" :rules="checkRules" ref="prepaidInfo" label-width="90px" :model="prepaidInfo" v-if="receiveData.title !== '提示'">
      <el-form-item label="预付金额：" prop="PretaxAmount">
        <el-input type="number" v-model.number="prepaidInfo.PretaxAmount" placeholder="预付金额请填写为负数"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="Remark">
        <el-input type="textarea" v-model="prepaidInfo.Remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmDialog('prepaidInfo')">确定</el-button>
    </span>
  </el-dialog>

</template>
<script>
export default {
  data() {
    var checkPretaxAmount = (rule, value, callback) => {
      if (!value === "") {
        return callback(new Error("请输入正确的数字金额"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入正确的数字金额"));
        } else {
            if (value === 0) {
              callback(new Error("预付金额不能为0"));
            } else {
              callback();
            }
        }
      }, 0);
    };
    return {
      prepaidInfo: {
        PretaxAmount: "",
        Remark: ""
      },
      checkRules: {
        PretaxAmount: [{ validator: checkPretaxAmount, trigger: "blur" }]
      }
    };
  },
  props: {
    dialogPragram: Object,
    isShowdialog: Boolean
  },
  computed: {
    receiveData() {
      return this.dialogPragram;
    },
    centerDialogVisible() {
      this.prepaidInfo = {};
      return this.isShowdialog;
    }
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    confirmDialog(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialogPragram.callback(this.prepaidInfo);
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
// @import "../../../common/scss/color.scss";

.add-media {
  .el-dialog__header {
    background-color: #409eff;
    padding: 10px 20px 10px;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-dialog__headerbtn {
    transform: translateY(-50%);
    .el-dialog__close {
      color: #fff;
    }
  }

  .el-dialog__body {
    padding: 20px 25px 0px;
    p {
      font-size: 16px;
      font-weight: 500;
      text-align: center;
    }
  }
  .el-select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/import-preview/add-advanced-dialog.vue